<template>
  <v-select
    ref="vselect"
    :label="label"
    :placeholder="placeholder"
    :multiple="multiple"
    :disabled="disabled"
    :options="options"
    :reduce="reduce"
    v-model="selected"
    @search:focus="focus"
    @search="search"
  />
</template>

<script>
import EnumeratesService from "@/services/enumerates.service";

import vSelect from "./vselect";

export default {
  name: "CountriesDropdown",
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    multiple: {
      type: Boolean,
      default() {
        return false;
      },
    },
    placeholder: {
      type: String,
      default() {
        return `Select ${
          this.multiple ? "one or multiple countries" : "a country"
        }`;
      },
    },
    value: {
      type: Object | Array,
      default() {
        return {};
      },
    },
    label: {
      type: String,
      default() {
        return "name";
      },
    },
    reduce: {
      type: Function,
      default: (option) => option,
    },
    filters: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    vSelect,
  },
  methods: {
    search(term, loading) {
      loading(true);

      this.query(term, this, loading);
    },
    focus() {
      if (this.empty) this.search("", this.$refs["vselect"].toggleLoading);
    },
    query(term, self, loading) {
      let params = Object.assign(
        {
          fields: "id,name",
        },
        this.filters
      );

      if (term) params.search = term;

      EnumeratesService.countries(params)
        .then(({ data }) => {
          this.options = data.map((item) => {
            return {
              id: item.id,
              name: item.name,
            };
          });
        })
        .catch(({ message }) => {
          this.error = message;
        })
        .finally(() => {
          loading(false);
        });
    },
  },
  watch: {
    selected(value) {
      this.$emit("input", value);
    },
    value(value) {
      this.selected = value;
    },
  },
  computed: {
    empty() {
      return this.options.length === 0;
    },
  },
  data() {
    return {
      error: null,
      selected: null,
      options: [],
    };
  },
};
</script>
